<template>
	<div class="account-information">
		<div class="view-title">
			<translate>Account Information</translate>
		</div>
		<div class="content">
			<div v-if="loading" v-loading="loading" class="m-h-200"></div>
			<el-row v-if="!loading">
				<el-col :span="6">
					<div class="account-avatar">
						<img :src="currentAccount.avatar | resetURL" class="avatar-img" />
						<p class="avatar-desc">
							<translate>avatar</translate>
						</p>
						<div class="upload-avatar" @click="fileClick()">
							<input class="upload-file" type="file" @change="onChange" id="file" accept="image/png,image/gif,image/jpeg" />
							<translate>Change</translate>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="team-info break-line">
						<p class="info-name">
							<span class="name-space">
								<translate>Team Name:</translate>
							</span>
							<span>{{ currentTeam.full_name }}</span>
						</p>
						<p>
							<span class="name-space"> <translate>Team code:</translate></span>
							<span>{{ currentTeam.domain }}</span>
						</p>
					</div>
				</el-col>
				<el-col :span="10">
					<div class="team-info">
						<p class="info-name">
							<span class="name-space">
								<translate>Display Nickname:</translate>
							</span>
							<span
								><span class="limit-text">{{ currentAccount.name }}</span> <i class="el-icon-edit edit-name" @click="showEditName()"></i
							></span>
						</p>
						<p>
							<span class="name-space">
								<translate>login account:</translate>
							</span>
							<span
								><span class="limit-text">{{ currentAccount.account }}</span></span
							>
						</p>
					</div>
				</el-col>
			</el-row>
		</div>

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import EditName from './model/account-edit-name.vue'
export default {
	name: 'accountInfo',
	data() {
		return {
			loading: true,
			currentTeam: {},
			currentRightPanel: null,
			rightPanelData: null,
		}
	},
	created() {
		this.getCurrentTeam()
	},
	computed: {
		currentAccount() {
			return this.$store.getters.account
		},
	},
	methods: {
		// get current team info
		getCurrentTeam() {
			this.$store.dispatch(STORE_CONST.TEAM.CURRENT).then(
				(res) => {
					this.loading = false
					this.currentTeam = Object.clone(this.$store.getters.team.setting)
				},
				() => {
					this.loading = false
				},
			)
		},
		fileClick() {
			document.getElementById('file').click()
		},
		onChange(e) {
			let files = e.target.files
			let allFiles = []
			for (let i = 0; i < files.length; i++) {
				let file = files[i]
				let reader = new FileReader()
				// Convert the file to base64 text
				reader.readAsDataURL(file)
				reader.onload = () => {
					// Make a fileInfo Object
					let fileInfo = {
						name: file.name,
						type: file.type,
						size: Math.round(file.size),
						base64: reader.result,
						file: file,
					}
					allFiles.push(fileInfo)
					// If all files have been proceed
					let flieType = fileInfo.type.split('/')[1]
					console.log('fileInfo,type', flieType)
					if (fileInfo.size > 1 * 1024 * 1024) {
						this.$notify({
							message: this.$gettext('The maximum supported file size is 1M.'),
							type: 'warning',
						})
					} else {
						if (flieType === 'png' || flieType === 'jpeg' || flieType === 'gif') {
							if (allFiles.length === files.length) {
								let params = {
									content: allFiles[0].base64.split('base64,')[1],
									extension: allFiles[0].name.split('.')[1],
									file_name: allFiles[0].name,
									file_size: allFiles[0].size,
								}
								this.$store.dispatch(STORE_CONST.ACCOUNT.CAANGE_AVATAR, params).then((res) => {
									let params = {
										avatar: '/file/' + res.url,
									}
									this.$store.dispatch(STORE_CONST.ACCOUNT.UPDATE, { data: params }).then((res) => {
										this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT)
										this.$notify({
											message: this.$gettext('Change avatar successfully!'),
											type: 'success',
										})
									})
								})
							}
						} else {
							this.$notify({
								type: 'warning',
								message: this.$gettext('wrong file type'),
							})
						}
					}
					e.target.value = ''
				}
			}
		},
		trimSapce(rule, value, callback) {
			console.log('rule', rule, value)
			if (value.match(/^\s+$/)) {
				if (this.currentRightPanel === EditName) {
					callback(new Error(this.$gettext('Please input the name')))
				}
			} else {
				value = value.trim()
				callback()
			}
		},
		showEditName() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'EditName' ? 0 : 300
			this.currentRightPanel = EditName
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						name: {
							label: this.$gettext('Display Nickname:'),
							labelWidth: 280,
							val: Object.clone(this.$store.getters.account.name),
							rule: [
								{
									required: true,
									message: this.$gettext('Please input the name'),
									trigger: 'blur',
								},
								{ max: 20, message: this.$gettext('length is within 20 characters'), trigger: 'change' },
								{ validator: this.trimSapce, trigger: 'blur' },
							],
						},
					}
				}, time)
			})
		},
		// 关闭右侧侧滑
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
	},
	components: {
		EditName,
	},
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.account-information {
	color: $textColor;
	.m-h-200 {
		min-height: 200px;
	}
	.content {
		padding: 15px;
		.el-row {
			background-color: #fff;
			padding: 20px 0;
			.el-col {
				border-right: 1px solid $border-color;
				&:last-child {
					border-right: none;
				}
				.account-avatar {
					position: relative;
					padding-top: 20px;
					text-align: center;
					.avatar-img {
						width: 50px;
						height: 50px;
						border-radius: 50%;
						&:hover {
							cursor: pointer;
							& ~ .upload-avatar {
								z-index: 1;
							}
						}
					}
					.avatar-desc {
						margin-top: 5px;
					}
					.upload-avatar {
						position: absolute;
						left: 50%;
						bottom: 27px;
						transform: translate(-50%);
						width: 50px;
						height: 50px;
						line-height: 50px;
						color: #fff;
						z-index: -1;
						border-radius: 50%;
						background-color: rgba(0, 0, 0, 0.4);
						&:hover {
							z-index: 1;
							cursor: pointer;
						}
						span {
							&:hover {
								cursor: pointer;
							}
						}
						.upload-file {
							display: none;
							position: absolute;
							font-size: 23px;
							width: 50px;
							height: 50px;
							right: 0;
							top: 0;
							opacity: 0;
							filter: alpha(opacity=0);
							&:hover {
								cursor: pointer;
							}
						}
					}
				}
				.team-info {
					padding: 30px 0 20px;
					&.break-line {
					}
					.info-name {
						margin-bottom: 10px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						.edit-name {
							padding: 10px;
							&:hover {
								color: $mainColor;
								cursor: pointer;
							}
						}
					}
					.limit-text {
						max-width: 280px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.name-space {
						display: inline-block;
						min-width: 30%;
						text-align: right;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// account-info.vue?ff86bbfa